import { createApi} from "@reduxjs/toolkit/query/react";
import {  stagingURL,  } from "../../views/Apis";
import { axiosBaseQuery } from "../axiosBaseQuery";

export const teamManagerApi = createApi({
    reducerPath: "teamManagerApi",
    baseQuery: axiosBaseQuery({ baseUrl:stagingURL }),
    endpoints: () => ({}),
});
